import { toaster } from '@optiaxiom/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import * as notificationService from '../services';

export function useNotificationActions() {
  const queryClient = useQueryClient();

  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: ['notifications'] });
  };

  const markAsRead = useMutation({
    mutationFn: notificationService.markAsRead,
    onSuccess: () => {
      invalidate();
    },
    onError: () => {
      toaster.create('Failed to update notification', { type: 'danger' });
    },
  });

  const markAsUnread = useMutation({
    mutationFn: notificationService.markAsUnread,
    onSuccess: () => {
      invalidate();
    },
    onError: () => {
      toaster.create('Failed to update notification', { type: 'danger' });
    },
  });

  const bulkMarkAsRead = useMutation({
    mutationFn: (params?: { ids?: string[]; group_id?: string }) =>
      notificationService.bulkMarkAsRead(params),
    onSuccess: () => {
      invalidate();
      toaster.create('Notifications marked as read', { type: 'success' });
    },
    onError: () => {
      toaster.create('Failed to update notifications', { type: 'danger' });
    },
  });

  const bulkMarkAsUnread = useMutation({
    mutationFn: (params?: { ids?: string[]; group_id?: string }) =>
      notificationService.bulkMarkAsUnread(params),
    onSuccess: () => {
      invalidate();
      toaster.create('Notifications marked as unread', { type: 'success' });
    },
    onError: () => {
      toaster.create('Failed to update notifications', { type: 'danger' });
    },
  });

  const deleteNotification = useMutation({
    mutationFn: notificationService.deleteNotification,
    onSuccess: () => {
      invalidate();
      toaster.create('Notification dismissed', { type: 'success' });
    },
    onError: () => {
      toaster.create('Failed to dismiss notification', { type: 'danger' });
    },
  });

  const bulkDelete = useMutation({
    mutationFn: (params?: { ids?: string[]; group_id?: string }) =>
      notificationService.bulkDelete(params),
    onSuccess: () => {
      invalidate();
      toaster.create('Notifications dismissed', { type: 'success' });
    },
    onError: () => {
      toaster.create('Failed to dismiss notifications', { type: 'danger' });
    },
  });

  return {
    markAsRead,
    markAsUnread,
    bulkMarkAsRead,
    bulkMarkAsUnread,
    deleteNotification,
    bulkDelete,
  };
}
